import constants from 'app/constants'
import { removeSpecialCharacters } from 'lib/util/string'

const DEFAULT_LAYER_ORDER = [
  'background',
  'back_prop',
  'base',
  'face',
  'skin_mod',
  'clothing',
  'clothing_accessories',
  'neck_accessories',
  'eyes',
  'mouth',
  'makeup',
  'nose',
  'face_mods',
  'facial_hair',
  'hats_hair',
  'headgear',
  'face_cyborg',
  'ears',
  'ear_accessories',
  'glasses',
  'fullbody',
  'hands'
]

/**
 * Parse the utilities
 *
 * @param {Array} list - the array of accessory utilities
 * @param {Array} utilityConfig - the utility configuration
 * @returns {object} the parsed utilities
 */
const parseUtility = (list, utilityConfig) => {
  const validUtilities = utilityConfig.map(item => item.id)

  const utility = list.reduce((res, item) => {
    const category = String(item?.utility_category || '').toLowerCase()

    if (!validUtilities.includes(category)) {
      return res
    }

    res.push({
      category: category || 'digital_collectible',
      title: item?.title || 'Collectible'
    })

    return res
  }, [])

  const hasCollectible = utility.find(
    item => item.category === 'digital_collectible'
  )

  if (!hasCollectible || !utility.length) {
    utility.push({ category: 'digital_collectible', title: 'Collectible' })
  }

  const utilityIds = utility.map(({ category }) => category)

  const primaryUtility = {
    id: utilityIds[0],
    label: utilityConfig?.find(item => item.id === utilityIds[0])?.titleShort,
    longLabel: utilityConfig?.find(item => item.id === utilityIds[0])?.title
  }

  return { utility, utilityIds, primaryUtility }
}

/**
 * Parse the elements array into object keys for faster
 * lookup
 *
 * @param {object} props - the input props
 * @returns {object} the parsed elements
 */
export default function parseElements (props) {
  const {
    DEFAULT_CREATED_BY,
    brands,
    categoryConfig,
    elements,
    prices,
    supply,
    utilityConfig
  } = props

  return elements.map(element => {
    const createdBy = removeSpecialCharacters(
      String(element?.createdBy || DEFAULT_CREATED_BY).toLowerCase()
    )
    const brand = brands[createdBy] || {
      title: 'Unknown'
    }
    const groupType = element.ear_type || null

    /* if (!brands[createdBy]) {
      console.log('missing:', createdBy)
    } */

    const { primaryUtility, utility, utilityIds } = parseUtility(
      Array.isArray(element?.utility) ? element.utility : [],
      utilityConfig
    )

    let gender = (
      element?.gender
        ? Array.isArray(element.gender)
          ? element.gender
          : [element.gender]
        : []
    ).map(item => item.toLowerCase())

    if (gender[0] === '') {
      gender = []
    }

    return {
      ...element,
      style: Array.isArray(element?.style) ? element.style : ['puks'],
      brand,
      isAvailable: Boolean(element?.isAvailable),
      color: element?.color || '',
      compatible: Array.isArray(element?.compatible) ? element.compatible : [],
      createdBy,
      exclusions: Array.isArray(element?.exclusions) ? element.exclusions : [],
      gender,
      groupType,
      hides: Array.isArray(element?.hides) ? element.hides : [],
      id:
        element?.id !== null && element?.id !== undefined
          ? Number(element.id)
          : -1,
      image: element?.image || '',
      additional_images: Array.isArray(element?.additional_images)
        ? element?.additional_images
        : [],
      isProduct: true,
      layer_order: Array.isArray(element?.layer_order)
        ? element.layer_order
        : DEFAULT_LAYER_ORDER,
      layer: element?.layer || '',
      layerLabel: categoryConfig?.[element?.layer]?.label || 'Base',
      limitedEdition: Boolean(element?.limited_edition),
      name: element?.name || 'Unknown',
      price: Number(prices[element?.id]) || 0,
      productImage: !element?.productImage
        ? element?.thumbnail
        : String(element?.productImage || '').replace(
            `${constants.PATH_CDN}/`,
            ''
        ),
      supply: Number(supply[element?.id]) || 0,
      thumbnail: element?.thumbnail || '',
      type: element?.type || null,
      utility,
      utilityIds,
      primaryUtility
    }
  })
}
